import { render } from "./Index.vue?vue&type=template&id=0b533dde&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0b533dde&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=0b533dde&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1732715967/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b533dde"]])

export default __exports__